import { CanadaState } from "@/Common/Resources/Lookups/Enums/CommonLookupCodes";

class GeographicInfoState {
    public Id: string;
    public CountryId: string;
    public Name: string;
    public AltName: string;
    public Type: string;
    public SubdivisionId: number;
    public SubdivisionCode: string; // CA-QC
    public Myle_LookupCode: string;
    public Myle_LookupTypeCode: string;

    public static StaticGetStatePartOfSubdivisionCode(provinceDictionaryId: string): string {
        if (IsNullOrWhiteSpace(provinceDictionaryId))
            return "";

        let geoInfoState = cacheStore.GetStateMedfarDictionariesById_MedfarDic(provinceDictionaryId);
        if (geoInfoState == null)
            return "";

        let stateCode = geoInfoState.SubdivisionCode;
        if (IsNullOrWhiteSpace(stateCode))
            return "";

        let splitCode = stateCode.split("-");
        if (splitCode.length == 1)
            return "";
        else
            return splitCode[1];
    }

    public static isNewFoundlandProvince(stateLookupId: string): boolean {
        return cacheStore.GetLookupIdForProvince(CanadaState.Newfoundland) === stateLookupId;
    }
}

export { GeographicInfoState };
